import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { ResumeSessionGuard } from './guards/resumeSession.guard';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  // { path: '**', redirectTo: 'auth' },
  {
    path: 'city',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/main-game/main-game.module').then(
        (m) => m.MainGameModule
      ),
  },
  {
    path: 'map',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/global-map/global-map.module').then(
        (m) => m.GlobalMapModule
      ),
  },
  {
    path: 'auth',
    canActivate: [ResumeSessionGuard],
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'auth/complete',
    redirectTo: 'map',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
